import { set } from '@/utils/vuex'

export default {
  setLoggingOn: set('loggingon'),
  setLoginFailed: set('loginfailed'),
  setnetworkError: set('networkerror'),
  setLoginError: set('loginerror')
}
